import { fatal } from 'utils/log';
import bind from 'utils/bind';
import { createFunctionFromString } from '../config/runtime-parser';
import { isFunction, isString, isObjectType } from 'utils/is';

export default function getComputationSignature(blcktive, key, signature) {
  let getter;
  let setter;

  // useful for debugging
  let getterString;
  let getterUseStack;
  let setterString;

  if (isFunction(signature)) {
    getter = bind(signature, blcktive);
    getterString = signature.toString();
    getterUseStack = true;
  }

  if (isString(signature)) {
    getter = createFunctionFromString(signature, blcktive);
    getterString = signature;
  }

  if (isObjectType(signature)) {
    if (isString(signature.get)) {
      getter = createFunctionFromString(signature.get, blcktive);
      getterString = signature.get;
    } else if (isFunction(signature.get)) {
      getter = bind(signature.get, blcktive);
      getterString = signature.get.toString();
      getterUseStack = true;
    } else {
      fatal('`%s` computation must have a `get()` method', key);
    }

    if (isFunction(signature.set)) {
      setter = bind(signature.set, blcktive);
      setterString = signature.set.toString();
    }
  }

  return {
    getter,
    setter,
    getterString,
    setterString,
    getterUseStack
  };
}
